import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

import { genericGetRequest_2, genericPostRequest } from "helpers/sf_backend_helper.js"

import { AppConfiguration } from "config"
import { bsh_getAdminUserDetails } from "helpers/sf_browser_storage_helper"
import { EXPORT_ENQUEUED_MESSAGE } from "helpers/sf_constants"
import ToastAlert, { ToastAlertIconType } from "components/Common/ToastAlert/ToastAlert"
import {
  exportAdminBulkEditJobsError,
  exportAdminBulkEditJobsSuccess,
  getAdminBulkEditJobsError,
  getAdminBulkEditJobsSuccess,
} from "./actions"
import { EXPORT_ADMIN_BULK_EDIT_JOBS, GET_ADMIN_BULK_EDIT_JOBS } from "./actionTypes"

function* onGetAdminBulkEditJobs(action) {
  try {
    const queryParams = action?.payload?.queryParams || {}
    const user = bsh_getAdminUserDetails()
    const response = yield call(
      genericGetRequest_2,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_bulk_edit_jobs`,
      queryParams,
      {
        Authorization: user.token,
      }
    )
    yield put(getAdminBulkEditJobsSuccess(response))
  } catch (error) {
    yield put(getAdminBulkEditJobsError(error))
  }
}

function* onExportAdminBulkEditJobs(action) {
  try {
    const queryParams = action?.payload?.queryParams || {}
    const user = bsh_getAdminUserDetails()
    const req = {
      body: JSON.stringify(queryParams),
      headers: {
        Authorization: user.token,
        "Content-Type": "application/json",
      },
    }
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_bulk_edit_jobs/export`,
      req,
    )
    yield put(exportAdminBulkEditJobsSuccess(response))
    ToastAlert.fire({ icon: ToastAlertIconType.OK, title: EXPORT_ENQUEUED_MESSAGE })
  } catch (error) {
    yield put(exportAdminBulkEditJobsError(error))
    ToastAlert.fire({ icon: ToastAlertIconType.ERROR, title: "Failed to queue bulk migration export." })
  }
}

function* adminBulkEditJobsSaga() {
  // Search/filter/sort/pagination on this grid can all dispatch overlapping
  // requests; takeLatest cancels any in-flight fetch so an older response
  // can never land after a newer one and overwrite it.
  yield takeLatest(GET_ADMIN_BULK_EDIT_JOBS, onGetAdminBulkEditJobs)
  yield takeEvery(EXPORT_ADMIN_BULK_EDIT_JOBS, onExportAdminBulkEditJobs)
}

export default adminBulkEditJobsSaga
